export enum CreateDocumentQueryAction {
    CREATE_DOCX = 'create-docx',
    CREATE_XLSX = 'create-xlsx',
}

export const isCreateDocumentQueryAction = (value: any): value is CreateDocumentQueryAction =>
    Object.values(CreateDocumentQueryAction).includes(value);
